export const MAIN_CLASS_NAME = 'toolset-modal';
export const MODAL_WIDE_CLASS_NAME = `${MAIN_CLASS_NAME}_wide`;
export const MODAL_MEDIUM_CLASS_NAME = `${MAIN_CLASS_NAME}_medium`;
export const MODAL_NARROW_CLASS_NAME = `${MAIN_CLASS_NAME}_narrow`;
export const RADIO_GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__radio-group`;
export const RADIO_GROUP_COLUMN_CLASS_NAME = `${RADIO_GROUP_CLASS_NAME}__column`;
export const RADIO_BUTTON_CLASS_NAME = `${RADIO_GROUP_CLASS_NAME}__button`;
export const RADIO_BUTTON_LABEL_CLASS_NAME = `${RADIO_BUTTON_CLASS_NAME}__label`;
export const RADIO_BUTTON_LABEL_TITLE_CLASS_NAME = `${RADIO_BUTTON_LABEL_CLASS_NAME}__title`;
export const PARAMETERS_CLASS_NAME = `${MAIN_CLASS_NAME}__parameters`;
export const FORM_ITEM_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__form-item`;
export const TABS_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__tabs`;
export const SECTION_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__section`;
export const SECTION_TITLE_CLASS_NAME = `${SECTION_CLASS_NAME}__title`;
export const SECTION_FORM_CLASS_NAME = `${SECTION_CLASS_NAME}__form`;
export const SECTION_FORM_ITEM_CLASS_NAME = `${SECTION_FORM_CLASS_NAME}__item`;
export const SUBTITLE_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__subtitle`;
export const TABLE_CLEAR_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__table-clear`;
export const TABLE_REMOVE_CLASS_NAME = `${PARAMETERS_CLASS_NAME}__table-remove`;
export const TOOL_NAMES_PREFIX_HINT_CLASS_NAME = `${FORM_ITEM_CLASS_NAME}__prefix-hint`;
export const ELMA365_TOOL_NAME_EXAMPLE = 'fetch_elma365_app_element';
export const SMART_SEARCH_TOOL_NAME_EXAMPLE = 'search_documents';

export const MODAL_WIDTH_DEFAULT = 680;
